import { FAILURE, POST, SUCCESS, GET, PUT } from "../utils/const/http-const";
import { getHeaders } from "./utils";
import { BASE_URL } from "../utils/const/base-url";
import { FORMATO_FECHA } from "../utils/const/formato-fecha";
import moment from "moment";

export async function obtenerListaSucursal(obj, combo = false, tag) {
    try {
        let data = { error: true };
        const { status, message, body } = await fetch(
            `${BASE_URL}/sucursal/obtener-lista-sucursal`,
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        if (status === SUCCESS) {
            data.error = false;
            data.data = body;
            if (combo === true) {
                data.data = data.data.map(item => ({
                    label: `${item.codigo} - ${item.descripcion}`,
                    value: item.id,
                }));
            }
            if (combo === false) {
                data.data = data.data.map(item => ({
                    ...item,
                    habilitadoLabel: item.habilitado ? tag("label_habilitado") : tag("label_deshabilitado"),
                    fechaProceso: moment(item.fechaProceso).format(FORMATO_FECHA.YYYY_MM_DD_HH_MM_SS),
                }));
            }
        }
        if (status === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("obtenerListaSucursal err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function crearSucursal(obj) {
    try {
        let data = { error: true };
        const { status, message } = await fetch(
            `${BASE_URL}/sucursal/crear-sucursal`,
            {
                headers: getHeaders(),
                method: POST,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        if (status === SUCCESS) {
            data.error = false;
            // data.data = body;
        }
        if (status === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("crearSucursal err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function modificarSucursal(obj) {
    try {
        let data = { error: true };
        const { status, message } = await fetch(
            `${BASE_URL}/sucursal/modificar-sucursal`,
            {
                headers: getHeaders(),
                method: PUT,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        if (status === SUCCESS) {
            data.error = false;
            // data.data = body;
        }
        if (status === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("modificarSucursal err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function deshabilitarSucursal(obj) {
    try {
        let data = { error: true };
        const { status, message } = await fetch(
            `${BASE_URL}/sucursal/deshabilitar-sucursal`,
            {
                headers: getHeaders(),
                method: PUT,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        if (status === SUCCESS) {
            data.error = false;
            // data.data = body;
        }
        if (status === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("deshabilitarSucursal err");
        console.log(err);
        return { error: true, message: err };
    }
}

export async function habilitarSucursal(obj) {
    try {
        let data = { error: true };
        const { status, message } = await fetch(
            `${BASE_URL}/sucursal/habilitar-sucursal`,
            {
                headers: getHeaders(),
                method: PUT,
                body: JSON.stringify(obj),
            }
        ).then((res) => res.json());
        if (status === SUCCESS) {
            data.error = false;
            // data.data = body;
        }
        if (status === FAILURE) {
            data.error = true;
            data.message = message;
        }
        return data;
    } catch (err) {
        console.log("habilitarSucursal err");
        console.log(err);
        return { error: true, message: err };
    }
}